'use strict';
var cid = 0;

/**
 * A class ID generator
 *
 * @param {string} prefix
 * @returns {string}
 */
function cidGenerator(prefix) {
    prefix = prefix || 'c';
    return prefix + cid++;
}

module.exports = cidGenerator;
